// Aktiver Mandant PRO BROWSER-TAB (Muster aus optiplan, src/lib/tab-tenant-context.ts).
//
// sessionStorage ist je Tab getrennt: Zwei Tabs können zwei Mandanten zeigen, ohne sich zu stören.
// Jede Anfrage an Supabase trägt den Mandanten als Kopfzeile `x-optitime-tenant`; die Datenbank
// prüft die Mitgliedschaft selbst (public.current_tenant_id) — der Browser behauptet nur.

export const TENANT_HEADER = "x-optitime-tenant";
const KEY = "optitime.tenant";

let current: string | null = read();

function read(): string | null {
  try {
    return sessionStorage.getItem(KEY) ?? localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function getActiveTenantId(): string | null {
  return current;
}

export function setActiveTenantId(tenantId: string | null): void {
  current = tenantId;
  try {
    if (tenantId) {
      sessionStorage.setItem(KEY, tenantId);
      // Zuletzt gewählter Mandant als Vorschlag für neue Tabs.
      localStorage.setItem(KEY, tenantId);
    } else {
      sessionStorage.removeItem(KEY);
    }
  } catch {
    // Privater Modus o. Ä.: Der Mandant gilt dann nur bis zum Neuladen.
  }
}
